import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { ChapterTag, Reveal } from "./shared";

export default function Chapter4Venue({ config }) {
  const [open, setOpen] = useState(false);
  const { venue } = config;

  return (
    <section className="relative bg-champagne py-28 md:py-40" data-testid="chapter-4">
      <div className="mx-auto max-w-6xl px-6 md:px-16">
        <ChapterTag n={3} title="El lugar" />
        <Reveal>
          <h2 className="mb-4 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight text-deep-black md:text-6xl">
            {venue.name}
          </h2>
          <p className="mb-12 flex items-center gap-2 text-sm font-light tracking-wide text-deep-black/60">
            <MapPin className="h-4 w-4 text-gold-soft" strokeWidth={1.4} /> {venue.address}
          </p>
        </Reveal>

        <Reveal>
          <div className="relative h-[52vh] w-full overflow-hidden rounded-2xl border border-deep-black/10 shadow-[0_20px_60px_-30px_rgba(10,10,10,0.4)]">
            <AnimatePresence mode="wait">
              {!open ? (
                <motion.button
                  key="illustrated"
                  data-testid="venue-reveal-button"
                  data-cursor="hover"
                  onClick={() => setOpen(true)}
                  exit={{ opacity: 0, scale: 1.05 }}
                  transition={{ duration: 0.6 }}
                  className="group absolute inset-0 flex flex-col items-center justify-center overflow-hidden bg-deep-black text-ivory"
                >
                  {/* artistic illustrated map */}
                  <div className="absolute inset-0 opacity-40">
                    <svg viewBox="0 0 800 400" className="h-full w-full" preserveAspectRatio="xMidYMid slice">
                      <g stroke="#BBA680" strokeWidth="0.7" fill="none" opacity="0.6">
                        {Array.from({ length: 14 }).map((_, i) => (
                          <line key={`v${i}`} x1={i * 60} y1="0" x2={i * 60 + 120} y2="400" />
                        ))}
                        {Array.from({ length: 8 }).map((_, i) => (
                          <line key={`h${i}`} x1="0" y1={i * 55} x2="800" y2={i * 55 - 40} />
                        ))}
                      </g>
                      <circle cx="400" cy="200" r="60" stroke="#BBA680" fill="none" strokeDasharray="4 6" />
                      <circle cx="400" cy="200" r="6" fill="#BBA680" />
                    </svg>
                  </div>
                  <MapPin className="relative z-10 mb-4 h-8 w-8 animate-float text-gold" strokeWidth={1} />
                  <p className="relative z-10 font-serif text-2xl italic md:text-3xl">Descubre el mapa</p>
                  <span className="relative z-10 mt-3 flex items-center gap-1 text-xs uppercase tracking-[0.3em] text-ivory/60 transition-colors group-hover:text-gold">
                    Toca para abrir <ArrowUpRight className="h-3 w-3" />
                  </span>
                </motion.button>
              ) : (
                <motion.iframe
                  key="map"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.8 }}
                  title="Venue map"
                  data-testid="venue-map-iframe"
                  src={venue.mapsEmbedUrl}
                  className="absolute inset-0 h-full w-full"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              )}
            </AnimatePresence>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
